













































import Vue from 'vue';
import pipeline from '@/pipeline';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import { EssaySupportText } from '@/store/modules/essay/state';
import EssayThemeSupportTextList from '@/components/EssayThemeSupportTextList.vue';
import BottomButton from '@/components/BottomButton.vue';

export default Vue.extend({
  components: {
    PipelineMenuWrapper,
    BackButton,
    EssayThemeSupportTextList,
    BottomButton,
  },
  computed: {
    title(): string {
      return this.$store.getters.selectedEssayTheme?.title;
    },
    description(): string {
      return this.$store.getters.selectedEssayTheme?.description;
    },
    supportTexts(): EssaySupportText[] {
      return (this.$store.getters.selectedEssayTheme?.supportTexts || [])
        .slice()
        .sort((prev: EssaySupportText, next: EssaySupportText) => {
          if (prev.position === next.position) return 0;
          if (prev.position > next.position) return 1;
          return -1;
        });
    },
  },
  created() {
    this.$store.dispatch('PULL_ESSAY_THEME_DETAILS');
  },
  methods: {
    essayStart() {
      pipeline.next();
    },
  },
});
